import { ICalendarioSsoModel } from "../interfaces/calendario-sso/ICalendarioSsoModel";

export class CalendarioSsoModel implements ICalendarioSsoModel{
    idCalendarioSso: number;
    anio: number;
    mes: number;
    nombreMes: string;
    fechaNotificacion: Date;
    fechaInicio: Date;
    fechaFin: Date;
    fechaCierre: Date;
    editable: boolean;
    comentarioAmpliacion: string;

    constructor(){
        this.idCalendarioSso = 0;
        this.anio = 0;
        this.mes = 0;
        this.nombreMes = '';
        this.fechaNotificacion = new Date();
        this.fechaInicio = new Date();
        this.fechaFin = new Date();
        this.fechaCierre = new Date();
        this.editable = false;
        this.comentarioAmpliacion = '';
    }
}